module.exports = __webpack_public_path__ + "media/images/icons/favorites_green-ef507ce272b63c08c2f6697195320a29.svg";